import { Outlet, Navigate, useLocation } from 'react-router';
import { observer } from 'mobx-react-lite';
import { useStore } from '@link/gds-supplier/stores';

const SupplierAdminRoute = () => {
  const { auth } = useStore();
  const location = useLocation();

  if (auth.isSupplierAdmin || auth.isAdmin || auth.isSupplierOperator) {
    return <Outlet />;
  } else {
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }
};
const ObserverSupplierAdminRoute = observer(SupplierAdminRoute);
export default ObserverSupplierAdminRoute;
